import React from 'react';
import PropTypes from 'prop-types';
import {Link, useMatch} from 'react-router-dom';
import classNames from 'classnames';
import {Tooltip} from 'antd';

import {APP_TITLE} from '@/env';
import UserAvatar from './UserAvatar';
import HeaderSubTitle from './context/HeaderSubTitle';
import {getLayout} from '@/util/AuthStore';

import styles from './AppLayoutHeader.module.less';

const layout = getLayout();
const svg = layout ? 'abbv-blue.svg' : 'abbv-white.svg';
const color = layout ? '#002c76' : '#fff';

const AppLayoutHeader = ({
    className,
    style,
    titleClassName,
    actionClassName,
    avatarProps,
    children,
}) => {
    const matchHome = useMatch('/');

    function renderHomeTitle() {
        return (
            <div className={classNames(styles.title, titleClassName)}>
                <img
                    src={require(`@/asset/logo/${svg || 'default.svg'}`).default}
                    alt="logo"
                    style={{height: 30}}
                />
                <h1>{APP_TITLE}</h1>
            </div>
        );
    }

    return (
        <div className={classNames(styles.container, className)} style={style}>
            <div className={styles.titleWrap}>
                {!matchHome ? (
                    <Tooltip title="返回首页" placement="right">
                        <Link to="/">{renderHomeTitle()}</Link>{' '}
                    </Tooltip>
                ) : (
                    renderHomeTitle()
                )}

                <HeaderSubTitle />
            </div>
            <div className={styles.actions}>
                {children}

                {/*<Link to="/docs" style={{display: 'flex', justify: 'center', alignItems: 'center'}}>
                    <QuestionCircleOutlined
                        style={{color: color, fontSize: 'x-large', marginRight: 10}}
                    />
                </Link>*/}

                <div className={classNames(styles.action, actionClassName)}>
                    <UserAvatar {...avatarProps} />
                </div>
            </div>
        </div>
    );
};

AppLayoutHeader.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    titleClassName: PropTypes.string,
    actionClassName: PropTypes.string,
    avatarProps: PropTypes.object,
    children: PropTypes.node,
};
export default AppLayoutHeader;
